module.exports = __webpack_public_path__ + "img/shape6.02bb3852.png";